import { WithInitialValue } from 'components/widgets/invest-component/interfaces/common'
import { PrimitiveAtom } from 'jotai'
import { atomsWithQuery } from 'jotai-tanstack-query'
import { Address } from 'viem'
import { AnatomyWithExtra } from '.'
import { sanitizeAddress } from 'services/query/hooks'

type QueryIndexAnatomyReturn = ReturnType<typeof atomsWithQuery<AnatomyWithExtra>>

export type QueryIndexAnatomyRequest = QueryIndexAnatomyReturn['0']
export type QueryIndexAnatomyDispatch = QueryIndexAnatomyReturn['1']

export type IndexAnatomyRequestAtoms = {
  indexAddress: PrimitiveAtom<Address> & WithInitialValue<Address>
  response: QueryIndexAnatomyRequest
  dispatch: QueryIndexAnatomyDispatch
}

export const getAnatomyQuery = (
  address: string,
) => `query {indexes(where: { id: "${sanitizeAddress(address)}" }) {
    chainID
    anatomy{
      chainIdSet
      currencyIdSets {
        chainIndex
        sets
      }
    }
    assets {
      chainID
      chainIndex
      assets {
        asset
        currencyID
        decimals
        symbol
      }
    }
    config {
      AUMDilutionPerSecond
      depositCustomCallback
      depositFeeInBP
      id
      metadata
      redemptionCustomCallback
      redemptionFeeInBP
      useCustomAUMFee
    }
  }}`
